export const PRIVATE_EVENT_TIME_MIN = "10:00";
export const PRIVATE_EVENT_TIME_MAX = "22:00";

const timePattern = /^([01]\d|2[0-3]):([0-5]\d)$/;

export const PRIVATE_EVENT_TIME_OPTIONS = Array.from(
  { length: 25 },
  (_, index) => {
    const totalMinutes = 10 * 60 + index * 30;
    const hour24 = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    const hour12 = hour24 % 12 || 12;
    const period = hour24 >= 12 ? "PM" : "AM";

    return {
      value: `${String(hour24).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`,
      label: `${hour12}:${String(minutes).padStart(2, "0")} ${period}`,
    };
  },
);

export function isPrivateEventTimeAllowed(value: string | undefined): boolean {
  if (!value) return true;

  const match = timePattern.exec(value);

  return (
    match !== null &&
    (match[2] === "00" || match[2] === "30") &&
    value >= PRIVATE_EVENT_TIME_MIN &&
    value <= PRIVATE_EVENT_TIME_MAX
  );
}
